import axios from "@/axios.js"

export default {
  searchElomarkUser({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/elomark_users/search_elomark_user/" + item)
        .then((response) => {
          commit('SET_ELOMARK_USER', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getElomarkManagers({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/elomark_users/get_elomark_managers`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getTimezones({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/elomark_users/timezones/" + item)
        .then((response) => {
          commit('SET_ALL_TIME_ZONES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAllLanguages({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/elomark_users/languages/" + item)
        .then((response) => {
          commit('GET_ALL_LANGUAGES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getTimeZone({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/elomark_users/get_timezone/${item}`)
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchStatus(context, statusId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/elomark_users/status/${statusId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchAutocomplete({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/elomark_users/search/" + item)
        .then((response) => {
          // // console.log(response)
          commit('SET_AUTOCOMPLETE_DATA', response.data.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateElomarkUser({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/elomark_users/update_elomark_user", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('EDIT_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addElomarkUser({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/elomark_users/add_elomark_users", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('ADD_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getElomarkRoleTypes({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/elomark_users/get_elomark_role_types")
        .then((response) => {
          // // console.log(response)
          commit('SET_ELOMARK_ROLE_TYPES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllLanguageCompetency({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/elomark_users/language/get_all_language_competency")
        .then((response) => {
          // // console.log(response)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getElomarkUserStatus({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/elomark_users/get_elomark_user_status")
        .then((response) => {
          // // console.log(response)
          commit('SET_ELOMARK_USER_STATUS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllElomarkUsers({
    commit
  },item) {
    return new Promise((resolve, reject) => {
      axios.get("/api/elomark_users/" + item.page_no + "/" + item.per_page)
        .then((response) => {
          commit('SET_ELOMARK_USERS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchCampaignAssociatedClientContact({
    commit
  },item) {
    return new Promise((resolve, reject) => {
      axios.get("/api/elomark_users/campaign_associated_client_contact/" + item)
        .then((response) => {
          commit('SET_CAMPAIGN_ASSOCIATED_CLIENT_CONTACT', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllElomarkUsersWithFilter({
    commit
  },item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/elomark_users/elomark_users_with_filter", {
          item: item
        })
        .then((response) => {
          commit('SET_ELOMARK_USERS', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchElomarkUser({
    commit
  }, elomarkUserId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/elomark_users/${elomarkUserId}`)
        .then((response) => {
          commit('SET_ELOMARK_USER', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchUserLanguages({
    commit
  }, elomarkUserId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/elomark_users/user_languages/${elomarkUserId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getElomarkUsersByRole(context, data) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/elomark_users/role/${data.role}/search/${data.search}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
    fetchElomarkUserList({
      commit
    },item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/elomark_users/${item}`)
        .then((response) => {
          commit('SELECTED_ACCOUNT', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeElomarkUser({
    commit
  }, elomarkUserId) {
    return new Promise((resolve, reject) => {
      // alert(elomarkUserId)
      axios.delete(`/api/elomark_users/${elomarkUserId}`)
        .then((response) => {
          commit('REMOVE_ACCOUNT', elomarkUserId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchLanguage(context, languageId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/elomark_users/language/${languageId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchLanguageCompetency(context, languageCompentencyId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/elomark_users/language_competency/${languageCompentencyId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getSalesDeveloperByCampaignId(context, data) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/elomark_users/role/${data.role}/campaign_id/${data.campaign_id}/search/${data.search}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
